import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Chip, Link, Typography } from '@mui/material';
import { formatTanggal, labelStatus } from './langgananUtil';

// Info paket & masa aktif cabang (read-only) untuk admin/staf. Perubahan hanya lewat superadmin.
const LanggananInfo = () => {
  const { user } = useSelector((state) => state.auth);
  const lg = user?.langganan;
  if (!lg) return null;

  const status = labelStatus(lg);
  const grup = new Map();
  (lg.fiturDetail || []).forEach((f) => {
    if (!grup.has(f.group)) grup.set(f.group, []);
    grup.get(f.group).push(f);
  });

  return (
    <Box sx={{ mt: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Typography variant="subtitle1" fontWeight={700} gutterBottom>Langganan Cabang</Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mb: 1 }}>
        <Typography variant="body1">Paket: <strong>{lg.paketNama || 'Tanpa paket'}</strong></Typography>
        <Chip size="small" label={status.text} color={status.color} />
      </Box>
      <Typography variant="body2" color="text.secondary">
        Masa aktif: {lg.permanen ? 'Permanen (tanpa expired)' : `berakhir pada ${formatTanggal(lg.masaAktifSampai)}`}
      </Typography>

      {(lg.fiturInti || []).length > 0 && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" fontWeight={600} gutterBottom>Fitur inti (selalu aktif)</Typography>
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            {lg.fiturInti.map((f) => <Chip key={f.key} size="small" label={f.label} />)}
          </Box>
        </Box>
      )}

      {grup.size > 0 && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" fontWeight={600} gutterBottom>Fitur tambahan dalam paket ini</Typography>
          {[...grup.entries()].map(([nama, fiturs]) => (
            <Box key={nama} sx={{ mb: 0.5 }}>
              <Typography variant="caption" color="text.secondary">{nama}</Typography>
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                {fiturs.map((f) => <Chip key={f.key} size="small" variant="outlined" label={f.label} />)}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {lg.kontak && (
        <Typography variant="body2" sx={{ mt: 1.5 }}>
          Untuk perpanjangan atau upgrade paket hubungi{' '}
          <Link href={lg.kontak.waLink} target="_blank" rel="noreferrer">{lg.kontak.tampil} (WhatsApp)</Link>.
        </Typography>
      )}
    </Box>
  );
};

export default LanggananInfo;
